@if (isVisible()) {
    <div class="fixed inset-0 bg-stone-950/35 backdrop-blur-[2px] flex justify-center items-center z-50 p-4 animate-fade-in" (click)="close()">
      <div class="bg-white rounded-2xl shadow-modal w-full p-6 text-stone-900 border-[1px] border-solid border-stone-200/90" [class]="maxWidth" (click)="$event.stopPropagation()">
        <div>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
}
  